import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getUserParticipantQualificationView } from "../../Utils/userFunctions";
import { toast } from "react-toastify";

let UserParticipantQualificationView = () => {
  const { surveyID } = useParams();
  const [qualificationJson, setQualificationJson] = useState("");
  const [surveyName, setSurveyName] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [deviceImage, setDeviceImage] = useState("");

  useEffect(() => {
    async function fetchAPI1() {
      const response = await getUserParticipantQualificationView(surveyID);

      if (response.status == "success") {
        let questions = JSON.parse(
          response.getParticipantQualificationJson
        ).map((item, i) => (
          <tr key={i++}>
            <td>{item.question}</td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <input
                className="participant_qualification_questions_1"
                type="radio"
                name="questions_name_36"
                defaultValue="yes"
                disabled
              />
            </td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <input
                className="participant_qualification_questions_1"
                type="radio"
                name="questions_name_36"
                defaultValue="no"
                disabled
              />
            </td>
          </tr>
        ));

        setQualificationJson(questions);
        setSurveyName(response.getSurveyName);
        setCompanyLogo(response.getCompanyLogo);
        setDeviceImage(response.getDeviceImage);
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  return (
    <div>
      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="survey-header">
          <div className="row">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box rounded-0">
                <center>
                  <img
                    src={companyLogo}
                    alt="image not available"
                    height={35}
                  ></img>
                </center>
              </div>
            </div>
          </div>

          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box device-box">
                <center>
                  <center>
                    <img
                      src={deviceImage}
                      alt="image not available"
                      className="form-box-device-image"
                    ></img>
                  </center>
                  <br></br>
                  <h6>
                    <b>{surveyName}</b>
                  </h6>
                </center>
              </div>
            </div>
          </div>

          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="action-button-view-page form-view-action">
                <Link
                  to={"/survey-form/preview/" + surveyID}
                  className="btn btn-sm custom-btn-primary pull-right"
                >
                  <i className="fa fa-arrow-left"></i> Back
                </Link>
              </div>
            </div>
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box">
                <table className="table table-bordered form-box-table">
                  <colgroup>
                    <col span={1} style={{ width: "70%" }} />
                    <col span={1} style={{ width: "15%" }} />
                    <col span={1} style={{ width: "15%" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th style={{ verticalAlign: "middle !important" }}>
                        Participant Qualification
                      </th>
                      <th
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        Yes
                      </th>
                      <th
                        className="text-center"
                        style={{ verticalAlign: "middle !important" }}
                      >
                        No
                      </th>
                    </tr>
                  </thead>
                  <tbody>{qualificationJson}</tbody>
                </table>

                <p>
                  <b>Confidentiality Disclaimer:</b> This document contains
                  confidential communication/information and is soley intended
                  for the use of recipient. The contents of this document may
                  not be copied without written permission from SARACA.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserParticipantQualificationView;
